export interface SearchDto {
  filters: SearchFilter[];
  sorts?: SortModel[];
  pageSize: number;
  pageNumber: number;
  sortBy?: SortModel;
}

export interface SearchFilter {
  field: string;
  value: string | boolean | undefined;
  operator?: SearchOperator | null;
}

export interface DataGridSearchModel {
    sortModel?: SortModel | undefined;
    pagingModel?: PagingModel | undefined;
}

export interface SortModel {
  field?: string | undefined;
  direction?: SortDirection | undefined;
}

export interface PagingModel {
    pageNumber?: number | undefined,
    pageSize?: number | undefined,
    totalRecords?: number | undefined,
}

export enum SortDirection {
  Ascending = 1,
  Descending = -1,
}

export enum SearchOperator {
  //bool
  IsTrue = 101,
  IsFalse = 102,

  //date
  Before = 201,
  OnOrBefore = 202,
  On = 203,
  NotOn = 204,
  OnOrAfter = 205,
  After = 206,

  //General
  LessThan = 301,
  LessThanEqualTo = 302,
  Equal = 303,
  NotEqual = 304,
  GreaterThanEqualTo = 305,
  GreaterThan = 306,

  //Strings
  StartsWith = 401,
  Contains = 402,
  EndsWith = 403,
  DoesNotStartWith = 404,
  DoesNotContain = 405,
  DoesNotEndWith = 406,

  //Collection
  In = 501,
  NotIn = 502,
}
